import { LoadableLazy } from '@confluence/loadable';

import type { RestrictionsDialogProps } from '../types';

export const RestrictionsDialogLoader = LoadableLazy<RestrictionsDialogProps>({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-RestrictionsDialog" */ './RestrictionsDialog'))
			.RestrictionsDialog,
});
